import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomPagination from "./CustomPagination";

const PaginatedList = ({
  setPaginatedList,
  searchInput,
  selectedSupplier,
  setShowSpinner,
  endPoint,
  endPoint2,
  limit = 100,
  setPurchasePaginatedList,
  setTotalPaid,
  purchaseLimit,
  refresh,
  filters,
}) => {
  const auth = useSelector((state) => state.authentication);
  const { userData } = auth;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();
  const [resetKey, setResetKey] = useState(0);

  const fetchData = useCallback(
    async (page) => {
      setShowSpinner(true);

      try {
        // ✅ MAIN ENDPOINT
        if (endPoint) {
          const response = await axios.get(
            `${process.env.REACT_APP_COLLEGE_ERP_API}${endPoint}`,
            {
              params: {
                branch: userData.branch,
                invoice_id: "",
                page,
                limit,
                searchInput,
                supplierId: selectedSupplier,
                startDate: filters?.fromDate,
                endDate: filters?.toDate,
              },
              headers: {
                Authorization: `Bearer ${userData.token}`,
              },
            }
          );

          setPaginatedList(response.data.items);
          setTotalPages(response.data.totalPages);
        }

        // ✅ SECOND ENDPOINT
        if (endPoint2) {
          const response = await axios.get(
            `${process.env.REACT_APP_COLLEGE_ERP_API}${endPoint2}`,
            {
              params: {
                branch: userData.branch,
                invoice_id: "",
                page,
                limit: purchaseLimit,
                searchInput,
                startDate: filters?.fromDate,
                endDate: filters?.toDate,
              },
              headers: {
                Authorization: `Bearer ${userData.token}`,
              },
            }
          );

          const { items, totalPages, totalPaid } = response.data;

          setPurchasePaginatedList(items);
          setTotalPaid(totalPaid);

          if (!endPoint) {
            setTotalPages(totalPages);
          }
        }
      } catch (err) {
        console.error("Error fetching data:", err);

        if (
          err.response?.data?.err?.name === "TokenExpiredError" ||
          err.response?.data?.message === "Unauthorized"
        ) {
          navigate("/");
          sessionStorage.clear();
        }
      } finally {
        setShowSpinner(false);
      }
    },
    [
      endPoint,
      endPoint2,
      limit,
      purchaseLimit,
      searchInput,
      selectedSupplier,
      filters?.fromDate,
      filters?.toDate,
      userData?.branch,
      userData?.token,
      setPaginatedList,
      setPurchasePaginatedList,
      setShowSpinner,
      setTotalPaid,
      navigate,
    ]
  );

  // ✅ ADDED filters?.fromDate AND filters?.toDate TO THE RESET TRIGGER
  useEffect(() => {
    setCurrentPage(1);
    setResetKey((prev) => prev + 1); // Triggers re-fetch on page 1 whenever filters or search change
  }, [searchInput, selectedSupplier, refresh, filters?.fromDate, filters?.toDate]);

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, resetKey, fetchData]);

  return (
    <div>
      <CustomPagination
        currentPage={currentPage}
        totalPages={totalPages}
        handlePageClick={(page) => setCurrentPage(page)}
      />
    </div>
  );
};

export default PaginatedList;